import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const NavigationPin_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 6C13.8981 6 9 10.802 9 16.6667C9 19.5523 10.1808 22.1731 12.1091 24.0981L12.1578 24.1467L19.417 33.7182C19.5471 33.8896 19.7617 34 20 34C20.2383 34 20.4529 33.8896 20.583 33.7182L27.8421 24.1468L27.8908 24.0982C29.8192 22.1732 31 19.5524 31 16.6667C31 10.802 26.1019 6 20 6ZM7 16.6667C7 9.64469 12.847 4 20 4C27.153 4 33 9.64469 33 16.6667C33 20.0877 31.6071 23.1894 29.3533 25.4639L22.1765 34.9267C21.6603 35.6074 20.8506 36 20 36C19.1493 36 18.3397 35.6074 17.8235 34.9267L10.6466 25.4638C8.39282 23.1893 7 20.0877 7 16.6667ZM20 10.5C16.6863 10.5 14 13.1863 14 16.5C14 19.8137 16.6863 22.5 20 22.5C23.3137 22.5 26 19.8137 26 16.5C26 13.1863 23.3137 10.5 20 10.5ZM12 16.5C12 12.0817 15.5817 8.5 20 8.5C24.4183 8.5 28 12.0817 28 16.5C28 20.9183 24.4183 24.5 20 24.5C15.5817 24.5 12 20.9183 12 16.5Z"
            />
        </SvgStyled>
    );
};

export default NavigationPin_xl;
